/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const HeartIcon = /*#__PURE__*/ createSvgIcon(
  'HeartIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.778 1.5A5.85 5.85 0 0110 3.248 5.85 5.85 0 0114.222 1.5c2.838.001 5.278 2.258 5.278 6.04 0 1.445-.597 2.911-1.442 4.27-.85 1.364-1.977 2.663-3.1 3.783a34.263 34.263 0 01-3.127 2.75c-.435.337-.807.607-1.083.794a6.875 6.875 0 01-.347.223 1.854 1.854 0 01-.133.072.81.81 0 01-.08.034h-.002a.555.555 0 01-.372 0h-.001a.814.814 0 01-.08-.034 1.87 1.87 0 01-.134-.072 6.902 6.902 0 01-.347-.223 22.078 22.078 0 01-1.083-.794 34.266 34.266 0 01-3.127-2.75c-1.123-1.12-2.25-2.419-3.1-3.783C1.097 10.45.5 8.985.5 7.54c0-3.782 2.44-6.039 5.278-6.04zm2.128 1.467A4.85 4.85 0 005.785 2.5H5.78C3.559 2.5 1.5 4.243 1.5 7.54c0 1.18.493 2.459 1.291 3.741.795 1.277 1.865 2.515 2.957 3.604a33.27 33.27 0 003.034 2.667c.422.328.777.584 1.032.757.071.049.133.09.186.123.053-.033.115-.074.186-.123.255-.173.61-.43 1.032-.757a33.266 33.266 0 003.034-2.667c1.092-1.089 2.162-2.327 2.957-3.604C18.007 10 18.5 8.721 18.5 7.54c0-3.297-2.058-5.04-4.28-5.04h-.005a4.85 4.85 0 00-3.825 1.813l-.39.486-.39-.486a4.85 4.85 0 00-1.704-1.346z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default HeartIcon;
